import { TrackingKey } from 'even-ts-static'

import { Experiment as ExperimentType } from '../types'

export enum ActionTypeKeys {
  EXPERIMENT_ACTIVATED = 'EXPERIMENT_ACTIVATED',
  EXPERIMENT_VARIANT_SELECTED = 'EXPERIMENT_VARIANT_SELECTED',
}

export interface ExperimentActivated {
  experiment: ExperimentType
  type: ActionTypeKeys.EXPERIMENT_ACTIVATED
}

export interface ExperimentVariantSelected {
  experiment: ExperimentType
  selectedVariantId: string
  trackingData: {
    experiment_id: string
    selected_variant: string
  }
  trackingKey: TrackingKey.ExperimentActivated
  type: ActionTypeKeys.EXPERIMENT_VARIANT_SELECTED
}

export const experimentActivated = (experiment: ExperimentType): ExperimentActivated => ({
  experiment,
  type: ActionTypeKeys.EXPERIMENT_ACTIVATED,
})

export const experimentVariantSelected = (
  experiment: ExperimentType,
  selectedVariantId: string,
): ExperimentVariantSelected => ({
  experiment,
  selectedVariantId,
  trackingData: {
    experiment_id: experiment.id,
    selected_variant: selectedVariantId,
  },
  trackingKey: TrackingKey.ExperimentActivated,
  type: ActionTypeKeys.EXPERIMENT_VARIANT_SELECTED,
})

export type ActionTypes = ExperimentActivated | ExperimentVariantSelected
